import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/api/index'
import Tracks from '@/core/tracks'
import user from './user'
import docSearch from './documents/search'
import docDetail from './documents/detail'
import productDetail from './products/detail'
import fastSearch from './products/fastSearch'
import list from './products/list'
import fanList from './products/fanList'
import pumpList from './products/pumpList'
import componentDetail from './components/detail'
import componentDownload from './components/download'
import componentList from './components/list'
import selectionList from './selections/list'
import shareParams from './shareParams'
import materialList from './material/list'
import moduleList from './module/list'
import goods from './goods'
import classification from './classification'
import scene from './scene'

Vue.use(Vuex)
Api.inject(Vuex.Store)
Tracks.inject(Vuex.Store)

const state = {
  desktopInfo: null,
  // 平台信息，默认web
  platform: 'web',
  softwareCode: null,
  softwareVersion: null,
  language: 'zh_CN',
  // 协同版：collaboration； 本地版：standalone
  edition: 'collaboration',
  fromEntrance: '',
  isSelectingEquipment: false,
  selectionParams: '',
  showLogin: false,
  // 是否展示插件登录蒙层的登录按钮
  showRLoginButton: true,
  showShopAnimation: false,
  brandCode: null // 临时添加凯泉水泵独立页面,brandCode是页面标识
}
const getters = {
  desktopInfo: (state) => { return state.desktopInfo },
  platform: (state) => { return state.platform },
  softwareCode: (state) => { return state.softwareCode },
  softwareVersion: (state) => { return state.softwareVersion },
  language: (state) => { return state.language },
  isStandalone: (state) => { return state.edition === 'standalone' },
  fromEntrance: (state) => { return state.fromEntrance },
  isFromEntrance: (state) => { return state.isSelectingEquipment },
  isSelectingEquipment: (state) => { return state.isSelectingEquipment },
  selectionParams: (state) => { return state.selectionParams },
  showLogin: (state) => { return state.showLogin },
  showRLoginButton: (state) => { return state.showRLoginButton },
  showShopAnimation: (state) => { return state.showShopAnimation },
  brandCode: (state) => state.brandCode,
  localAppData: (state) => { return state.localAppData },
  loginAppDataPath: (state) => { return state.loginAppDataPath },
}
const mutations = {
  setDesktopInfo(state, data) {
    state.desktopInfo = data
  },
  setPlatform(state, data) {
    state.platform = data
  },
  setSoftwareCode(state, data) {
    state.softwareCode = data
  },
  setSoftwareVersion(state, data) {
    state.softwareVersion = data
  },
  setLanguage(state, data) {
    state.language = data
  },
  setEdition(state, data) {
    state.edition = data
  },
  setFromEntrance(state, data) {
    state.fromEntrance = data
  },
  setIsSelectingEquipment(state, data) {
    state.isSelectingEquipment = data
  },
  setSelectionParams(state, data) {
    state.selectionParams = data
  },
  setShowLogin(state, data) {
    state.showLogin = data
  },
  setShowRLoginButton(state, data) {
    state.showRLoginButton = data
  },
  setShowShopAnimation(state, data) {
    state.showShopAnimation = data
  },
  setBrandCode(state, data) {
    state.brandCode = data
  },
  setLocalAppData(state, data) {
    state.localAppData = data
  },
  setLoginAppDataPath(state, data) {
    state.loginAppDataPath = data
  },
}
export default new Vuex.Store({
  state,
  getters,
  mutations,
  modules: {
    user,
    docSearch,
    docDetail,
    productDetail,
    fastSearch,
    list,
    fanList,
    pumpList,
    componentDetail,
    componentDownload,
    componentList,
    selectionList,
    shareParams,
    materialList,
    moduleList,
    goods,
    classification,
    scene,
  }
})
